import { Component } from "react"
import PropTypes from "prop-types"

import QueryList from "./query_list"
import QueryForm from "./query_form"
import QueryFields from "../query_fields"
import Ingredients from "../ingredients"

class QueryRouter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      view: this.props.view,
      queries: this.props.queries,
      query: this.props.query,
    }
  }

  updateRouter = (action, query) => {
    switch (action) {
      case "index":
        this.setState({ view: action })
        window.history.pushState(
          window.history.state,
          "Queries",
          this.props.queriesUrl
        )
        break
      case "new":
        this.setState({ view: action })
        window.history.pushState(
          window.history.state,
          "Create New Query",
          `${this.props.queriesUrl}/new`
        )
        break
      case "edit":
        this.setState({ view: action, query })
        window.history.pushState(
          window.history.state,
          "Edit Query",
          `${this.props.queriesUrl}/${query.module_name}`
        )
        break
      case "edit_replace":
        this.setState({ view: "edit", query })
        window.history.replaceState(
          window.history.state,
          "Edit Query",
          `${this.props.queriesUrl}/${query.module_name}`
        )
        break
      default:
    }
  }

  updateQueries = (action, data) => {
    let queries = this.state.queries
    switch (action) {
      case "add":
        queries = [...queries, data]
        break
      case "update":
        const index = queries.findIndex(q => q.id === data.id)
        queries = [
          ...queries.slice(0, index),
          data,
          ...queries.slice(index + 1),
        ]
        break
      case "replace_all":
        queries = [...data]
        break
      case "delete":
        queries = queries.filter(q => q.id !== data.id)
        break
      default:
    }
    this.setState({ queries })
  }

  render() {
    switch (this.state.view) {
      case "index":
        return (
          <QueryList
            {...this.props}
            key={this.state.queries.map(i => i.id).join(":")}
            queries={this.state.queries}
            updateRouter={this.updateRouter}
            updateQueries={this.updateQueries}
          />
        )
      case "new":
        return (
          <QueryForm
            {...this.props}
            query={{}}
            updateRouter={this.updateRouter}
            updateQueries={this.updateQueries}
            create
          />
        )
      case "edit":
        return (
          <>
            <QueryForm
              {...this.props}
              query={this.state.query}
              updateRouter={this.updateRouter}
              updateQueries={this.updateQueries}
            />
            <QueryFields
              service={this.props.service}
              query={this.state.query}
              protocolUrl={`${this.props.protocolUrl}/${this.state.query.module_name}`}
              referenceUrl={this.props.referenceUrl}
            />
            <Ingredients
              service={this.props.service}
              parent={this.state.query}
              parentType="Query"
              glossaryUrl={this.props.glossaryUrl}
              queries={this.state.queries}
            />
          </>
        )
      default:
        return <div>NOT FOUND</div>
    }
  }
}

QueryRouter.propTypes = {
  service: PropTypes.object.isRequired,
  queries: PropTypes.array.isRequired,
  query: PropTypes.object,
  queriesUrl: PropTypes.string.isRequired,
  referenceUrl: PropTypes.string.isRequired,
  glossaryUrl: PropTypes.string.isRequired,
  protocolUrl: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
}

export default QueryRouter
